module.exports = __webpack_public_path__ + "media/react/pages/mock_tests/free/assets/magoosh_brain-478c7495f14f0bbdc473ba1569b1a195.png";